import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api";

export interface StaffTenant {
	id: string;
	shopDomain: string;
	name: string | null;
	status: string;
}

export const useStaffTenants = (enabled: boolean) =>
	useQuery({
		queryKey: ["staff-tenants"],
		queryFn: () => api.get<{ items: StaffTenant[] }>("/api/staff/tenants"),
		enabled,
		staleTime: 5 * 60 * 1000,
	});

export const useSwitchTenant = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (tenantId: string) => api.post("/api/staff/switch", { tenantId }),
		// The session cookie now points somewhere else, so everything held in
		// memory belongs to the previous store.
		onSuccess: () => {
			queryClient.clear();
			window.location.assign("/");
		},
	});
};
